var render = function render(){var _vm=this,_c=_vm._self._c;return _c('admin-payment',{attrs:{"title":"Pagina de Pagamento"}},[_c('div',{staticClass:"row"},[(!_vm.plan.id)?_c('div',[_c('h1',[_vm._v("Plano não encontrado")])]):_vm._e(),_vm._v(" "),(_vm.plan.id)?_c('div',[_c('h1',[_vm._v(_vm._s(_vm.plan.name))]),_vm._v(" "),_c('pre',[_vm._v(_vm._s(_vm.plan.description))])]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }